import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = "(max-width: 640px)";

const hasMatchMedia = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

const useMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() =>
    hasMatchMedia() ? window.matchMedia(MOBILE_BREAKPOINT).matches : false
  );

  useEffect(() => {
    if (!hasMatchMedia()) return;

    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);

    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return isMobile;
};

export default useMobile;
